export default "__VITE_ASSET__eb861328__"